export default __webpack_public_path__ + "059239d9.jpg";